import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { USER_PREFERENCE_API } from "../apiRoutes";

const mutateUpdateUserPreference = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${USER_PREFERENCE_API}/${id}`, data);
};

const useUpdateUserPreferenceMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateUserPreference,
    ...queryParams,
  });

export default useUpdateUserPreferenceMutation;
